import React from "react";
import { LOGO_ICO } from "../utils/constants/images";

const AuthNavBar = () => {
  return (
    <div className="w-full relative px-2 md:px-10 p-3 flex justify-center items-center">
      <img
        alt="logo"
        src={LOGO_ICO}
        className="w-20 h-20  md:hidden object-contain"
      />
    </div>
  );
};

export default AuthNavBar;
